import { CareProgressSummary } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { baseApi, RTKQueryTag } from '../../../data/baseApi'

type GetCareProgressSummaryArgs = {
  episodeId?: string
  providerId: string
}

const careProgressSummaryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCareProgressSummary: builder.query<CareProgressSummary, GetCareProgressSummaryArgs>({
      query: ({ episodeId, providerId }) => ({
        method: 'get',
        url: `/v1/care-progress-summary`,
        params: { episode_id: episodeId, provider_id: providerId },
      }),
      providesTags: [RTKQueryTag.CARE_PROGRESS_SUMMARY],
    }),
  }),
})

export const { useGetCareProgressSummaryQuery } = careProgressSummaryApi
export default careProgressSummaryApi
